import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Obstacle } from '../models/obstacle.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { RunwayService } from '../service/runway.service';
var EditAreaObstacleComponent = /** @class */ (function () {
    function EditAreaObstacleComponent(_matDialogRef, _snackBar, data, _runwayService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._runwayService = _runwayService;
        this.isLoading = true;
        this.isNew = false;
        this.obstacle = data.obstacle || new Obstacle();
        this.airportId = data.airportId;
        this.takeoffLandAreaId = data.takeoffLandAreaId;
        this.isNew = data.isNew || false;
        this.origObstacle = Object.assign(new Obstacle(), data.obstacle);
    }
    EditAreaObstacleComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            heightAgl: new FormControl(this.obstacle.heightAgl, [Validators.pattern('^\\d{0,10}$')]),
            obstacleType: new FormControl(this.obstacle.obstacleType, [Validators.required, Validators.maxLength(100)]),
            distanceFromEnd: new FormControl(this.obstacle.distanceFromEnd, [Validators.pattern('^\\d{0,10}$')]),
            centerlineOffset: new FormControl(this.obstacle.centerlineOffset, [Validators.pattern('^\\d{0,10}$')]),
            offsetDirection: new FormControl(this.obstacle.offsetDirection, [Validators.maxLength(10)]),
            clearanceSlope: new FormControl(this.obstacle.clearanceSlope, [Validators.pattern('^\\d{0,10}\\.?\\d{0,2}$')]),
            marking: new FormControl(this.obstacle.marking, [Validators.maxLength(200)])
        });
        this.isLoading = false;
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditAreaObstacleComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        result = void 0;
                        this.obstacle.takeoffLandAreaId = this.takeoffLandAreaId;
                        this.obstacle.heightAgl = this.formGroup.value.heightAgl;
                        this.obstacle.obstacleType = this.formGroup.value.obstacleType;
                        this.obstacle.distanceFromEnd = this.formGroup.value.distanceFromEnd;
                        this.obstacle.centerlineOffset = this.formGroup.value.centerlineOffset;
                        this.obstacle.offsetDirection = this.formGroup.value.offsetDirection;
                        this.obstacle.clearanceSlope = this.formGroup.value.clearanceSlope;
                        this.obstacle.marking = this.formGroup.value.marking;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._runwayService.postObstacle(this.airportId, this.obstacle)];
                    case 1:
                        result = _a.sent();
                        this.obstacle = Obstacle.parse(result);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._runwayService.putObstacle(this.airportId, this.obstacle)];
                    case 3:
                        result = _a.sent();
                        this.obstacle = Obstacle.parse(result);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, obstacle: this.obstacle });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_1 });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditAreaObstacleComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditAreaObstacleComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.obstacle, this.origObstacle);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditAreaObstacleComponent;
}());
export { EditAreaObstacleComponent };
